import '@/utils/i18n'

export const onRouteUpdate = ({ location }) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-WPWXY7F4LX', {
      page_path: location.pathname
    })
  }
}
